import { serialize } from "./object-to-formdata";

/**
 * @module utils/object
 * @author caoshitong@moretickets.com
 * @description JS对象操作
 */

/**
 * @description 根据传入对象的路径取值
 * @param {object} 传入对象 eg. {a:{b:{c:{d:111}}}}
 * @param {string} 属性path  eg. a.b.c.d
 * @returns { * } 跟据路径获取到的 value
 */
const get = (target: any, propertyPath: string) => {
  let srcObj: { [index: string]: any } = target;
  const paths = propertyPath.split(".");

  for (let index = 0; index < paths.length; index += 1) {
    const key = paths[index];
    if (srcObj[key]) {
      srcObj = srcObj[key];
    } else {
      return undefined;
    }
  }
  return srcObj;
};

/**
 * @description 对象深拷贝
 * @param {source} object - 被拷贝的对象
 * @return {target} 新对象
 */
const deepClone = (source: any) => {
  const obj: { [index: string]: any } = source;
  let targetObj: { [index: string]: any } = {};
  // 递归出口
  // if (typeof obj !== 'object' || obj == null) {
  if (typeof obj !== "object" || !obj) {
    return obj;
  }

  if (obj instanceof Array) {
    targetObj = [];
  }

  Object.keys(obj).forEach((key) => {
    targetObj[key] = deepClone(obj[key]);
  });

  return targetObj;
};

/**
 *
 * @description object 转数组
 * @todo 可能不需要设置为 formdata, 只需要设置contentType即可
 * @param {object} obj - 原始对象
 * @returns {object} formdata
 */
const objectToFormData = serialize;

export default {
  get,
  deepClone,
  objectToFormData,
};
